
function initAnimation() {
 
  function stickerAnimation() {
    ScrollTrigger.create({
      trigger: ".js-pin-section",
      start: "top top",
      end: '+=550',
      pin: '.section--text-image-block',
      onUpdate: self => {
        if (self.progress >= 0.4) {
          self.pin.classList.add("active");
        } else {
          self.pin.classList.remove("active");
        }
      }
    });
  }

  setTimeout(() => {

    ScrollTrigger.matchMedia({
      "(max-width: 1024px)": () => stickerAnimation(),
    });
  }, 1)
}

document.addEventListener('DOMContentLoaded', initAnimation);